'use strict';

/**
 * @function
 * @description Updates the number of the remaining character
 * based on the character limit in a text area
 */
const limitCharacters = () => {
    $('form').find('textarea[data-character-limit]').each(function () {
        const characterLimit = $(this).data('character-limit');
        const charCountHtml = String.format(Resources.CHAR_LIMIT_MSG,
            '<span class="char-remain-count">' + characterLimit + '</span>',
            '<span class="char-allowed-count">' + characterLimit + '</span>');
        let charCountContainer = $(this).next('div.char-count');
        if (charCountContainer.length === 0) {
            charCountContainer = $('<div class="char-count"/>').insertAfter($(this));
        }
        charCountContainer.html(charCountHtml);
        // trigger the keydown event so that any existing character data is calculated
        $(this).change();
    });
};

module.exports = limitCharacters;
